var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link sort-container",attrs:{"type":"button"},on:{"click":_vm.onSort}},[_vm._t("default"),_vm._v(" "),_c('i',{class:_vm.orderClasses})],2)}
var staticRenderFns = []

export { render, staticRenderFns }